let lazyImages = $('.lazy-image');
let lazyBgs = $('.lazy-bg');

function lazyLoad() {
	var yScrollPosition = $(window).scrollTop() + $(window).innerHeight()

	lazyImages.each(function(index, image) {
		$image = $(image);
		if ($image.is(':hidden')) {
			return
		}
		
		var src = $image.data('src')
		var imageOffset = $image.offset().top - $(window).scrollTop();
		
		if ((!$image.hasClass("loaded") && imageOffset < yScrollPosition ) || isIe() ){
			$image.attr('src', src).addClass('loaded');
		}
	})
	
	lazyBgs.each(function(index, div) {
		$div = $(div);
		var divOffset = $div.offset().top - $(window).scrollTop()
				
		if ((!$div.hasClass("loaded") && divOffset < yScrollPosition) || isIe() ){
			$div.css('background-image', 'url(' + div.dataset.src + ')');
			$div.addClass('loaded')
		}
		
	})
	
	
	if ($('.lazy-image:not(.loaded)').length == 0 && $('.lazy-bg:not(.loaded)').length == 0) {
		$(window).unbind('scroll', lazyLoad);
		$(window).unbind('resize', lazyLoad);
	}
}

lazyLoad();

$(window).on('scroll', lazyLoad);
$(window).on('resize', lazyLoad);


function isIe(){
	var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    return (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
}

